const DEFAULT_COACH_AVATAR =
  'https://www-yns-com.s3.amazonaws.com/images/icon_coach_generic.png'

export function getCoachAvatarUrl(coach) {
  return coach?.bigAvatar || coach?.avatar || DEFAULT_COACH_AVATAR
}

export { DEFAULT_COACH_AVATAR }
